import React from 'react';
import { DISCLAIMER } from '../data/polski';
export function Footer() {
  return <footer className="w-full bg-slate-900 px-8 py-14 text-stone-50 sm:px-14" data-id="element-122" data-mp="3gf96t1ka0gbl">
      <div className="mx-auto max-w-6xl" data-id="element-123" data-mp="3ghc0bvkn0rl2">
        <p className="font-serif text-3xl tracking-tight" data-id="element-124" data-mp="32oniuyfytg6u">
          POLSKI GOTOWY<span className="align-super text-[0.5em]" data-id="element-125" data-mp="36pfufycb7x6a">™</span>
        </p>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone-50/60" data-id="element-126" data-mp="36nd4tff2k623">
          {DISCLAIMER} POLSKI GOTOWY™ · edulabs
        </p>
        <p className="mt-10 border-t border-white/10 pt-6 text-xs text-stone-50/60" data-id="element-127" data-mp="3991alritibr">
          © 2026 POLSKI GOTOWY™. Wszelkie prawa zastrzeżone.
        </p>
      </div>
    </footer>;
}